import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import HistoryCtwaCampaignsAPI from '../../api/historyCtwaCampaigns';

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isCreating: false
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getHistoryCtwaCampaigns(_state) {
    return _state.records;
  }  
};

export const actions = {
  get: async ({ commit }, data) => {
    commit(types.SET_HISTORY_CTWA_CAMPAIGNS_TEMPLATE_UI_FLAG, { isFetching: true });

    try {
      const response = await HistoryCtwaCampaignsAPI.get(data);
      commit(types.SET_HISTORY_CTWA_CAMPAIGNS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_HISTORY_CTWA_CAMPAIGNS_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_HISTORY_CTWA_CAMPAIGNS_TEMPLATE_UI_FLAG, { isCreating: true });

    try {
      const response = await HistoryCtwaCampaignsAPI.create(data);

      commit(types.ADD_HISTORY_CTWA_CAMPAIGNS, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_HISTORY_CTWA_CAMPAIGNS_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },
};

export const mutations = {
  [types.SET_HISTORY_CTWA_CAMPAIGNS_TEMPLATE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_HISTORY_CTWA_CAMPAIGNS]: MutationHelpers.create,
  [types.SET_HISTORY_CTWA_CAMPAIGNS]: MutationHelpers.set,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
